<template>
  <div class="reviewsBlock" :class="props.classes">
    <template v-for="review in reviews">
      <a
        v-if="review.id === 'shopperapproved'"
        :key="review"
        target="_blank"
        class="sa-widget-wrapper"
        rel="noopener"
        :href="review.link"
        :title="review.id"
      >
        <div class="widget-stars">
          <ul class="star-list shopperapproved-stars">
            <li class="sa-star"></li>
            <li class="sa-star"></li>
            <li class="sa-star"></li>
            <li class="sa-star"></li>
            <li class="sa-star"></li>
          </ul>
        </div>
        <div class="widget-powered-by">
          <div class="sa-logo"></div>
        </div>
      </a>

      <a
        v-if="review.id === 'trustpilot'"
        :key="review"
        target="_blank"
        class="tp-widget-wrapper"
        rel="noopener"
        :href="review.link"
        :title="review.id"
      >
        <div class="widget-stars">
          <ul class="star-list">
            <li class="tp-star"></li>
            <li class="tp-star"></li>
            <li class="tp-star"></li>
            <li class="tp-star"></li>
            <li class="tp-star"></li>
          </ul>
        </div><div class="widget-powered-by">
          <div class="tp-logo"></div>
        </div>
      </a>
    </template>
  </div>
</template>

<script setup>
const { confNavigation } = useConfig()
/**
* Props
*/
const props = defineProps({
  classes: {
    type: [String],
    default: ''
  },
  externalReviews: {
    type: [Object],
    default: null
  }
})

/**
* Default Reviews
*/
const reviews = computed({
  get () {
    if (props.externalReviews) {
      return props.externalReviews
    }

    return confNavigation.reviews
  }
})
</script>

<style lang="scss" scope>
.reviewsBlock {
  .sa-widget-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: auto;
    height: 28px;
    margin: 0 auto .25rem;
    .widget-stars {
      margin-right: .375rem;
      .star-list {
        display: flex;
        align-items: center;
        margin: 0;
        .sa-star {
          display: block;
          width: 19px;
          height: 19px;
          margin-right: 2px;
          background: transparent url("/assets/general/img/sa-star.svg") 0 0 no-repeat;
        }
      }
    }
    .widget-powered-by {
      margin: 0 .375rem;
      line-height: 1;
      .sa-logo {
        display: block;
        width: 5rem;
        height: 1.375rem;
        background: transparent url("/assets/general/img/sa_logo.svg") 0 0 no-repeat;
        background-size: contain;
      }
    }
  }

  .tp-widget-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: auto;
    height: 28px;
    margin: 0 auto .25rem;
    .widget-stars {
      margin-right: .375rem;
      .star-list {
        display: flex;
        align-items: center;
        margin: 0;
        .tp-star {
          display: block;
          width: 19px;
          height: 19px;
          margin-right: 2px;
          background: #00b67a url("/assets/general/img/tp_star.svg") 0 0 no-repeat;
        }
      }
    }
    .widget-powered-by {
      margin: 0 .375rem;
      line-height: 1;
      .tp-logo {
        display: block;
        width: 5rem;
        height: 1.125rem;
        margin-bottom: .25rem;
        background: transparent url("/assets/general/img/tp_logo.svg") 0 0 no-repeat;
        background-size: contain;
      }
    }
  }

  // Reverse
  &.reverse {
    color: #fff;
    .widget-powered-by {
      .sa-logo {
        background: transparent url("/assets/general/img/sa_logo_dark.svg") 0 0 no-repeat;
      }
      .tp-logo {
        background: transparent url("/assets/general/img/tp_logo_dark.svg") 0 0 no-repeat;
      }
    }
  }
}
</style>
